var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticClass:"d-flex",staticStyle:{"background-color":"var(--v-backgroundForm-base)"},attrs:{"width":"100%","height":"100%"}},[_c('v-layout',{staticClass:"fill-height",attrs:{"column":""}},[_c('Dashboard')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }